import { onResize, removeResize, respond, respondUntil, MOBILE, TABLET, DESKTOP } from '~/utils/breakpoints';
import I18n from '~/utils/translations';
import React, { Component } from 'react';
import Slider from 'react-slick';
import CarouselArrow from 'components/carousel_arrow';
export default class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      previewSlider: null,
      thumbnailSlider: null,
      visibleThumbnails: this.thumbnailsToShow(),
      currentSlide: 0,
    };
  }

  componentDidMount() {
    this.setState({
      previewSlider: this.previewSlider,
      thumbnailSlider: this.thumbnailSlider,
    });

    onResize(this.setVisibleThumbnails);
    document.addEventListener('keydown', this.onKeyPress, true);
  }

  componentWillUnmount() {
    removeResize(this.setVisibleThumbnails);
    document.removeEventListener('keydown', this.onKeyPress, true);
  }

  onKeyPress = (key) => {
    // key.stopPropagation() stops arrow keys changing
    // header slider image while the modal is open

    if (key.code == 'ArrowLeft') {
      key.stopPropagation();

      this.state.previewSlider.slickPrev();
    } else if (key.code == 'ArrowRight') {
      key.stopPropagation();

      this.state.previewSlider.slickNext();
    }
  };

  render() {
    return (
      <div className="photo-gallery">
        <div className="photo-gallery__main-image">
          {respondUntil(MOBILE) && <div className="photo-gallery__info">{this.renderGalleryInformation()}</div>}
          <div className="photo-gallery__main-image-with-arrows">
            {respondUntil(DESKTOP) && (
              <CarouselArrow arrow={'previous'} slider={this.previewSlider} slides={this.props.slides} />
            )}
            <Slider
              className="photo-gallery__image-slider"
              asNavFor={this.state.thumbnailSlider}
              ref={(slider) => (this.previewSlider = slider)}
              fade={true}
              arrows={false}
              swipe={true}
              slidesToScroll={1}
              beforeChange={this.updateInformation}
              speed={200}
            >
              {this.generateImages()}
            </Slider>
            {respondUntil(DESKTOP) && (
              <CarouselArrow arrow={'next'} slider={this.previewSlider} slides={this.props.slides} />
            )}
          </div>
        </div>
        <div className="photo-gallery__slider">
          {this.renderThumbnailSlider()}
          <div className="photo-gallery__info">{this.renderGalleryInformation()}</div>
        </div>
      </div>
    );
  }

  setVisibleThumbnails = () => {
    this.setState({
      visibleThumbnails: this.thumbnailsToShow(),
    });
  };

  thumbnailsToShow = () => {
    if (respond(TABLET)) {
      return this.props.slides.length <= this.props.maxThumbnailsToShow
        ? this.props.slides.length - 1
        : this.props.maxThumbnailsToShow;
    } else {
      return this.props.slides.length <= this.props.maxThumbnailsToShow
        ? this.props.slides.length - 1
        : this.props.minThumbnailsToShow;
    }
  };

  generateImages = () => {
    return this.props.slides.map((slide) => (
      <div key={slide.img} className="photo-gallery__image-wrapper">
        <img className="photo-gallery__image" src={slide.img} alt={slide.description} />
      </div>
    ));
  };

  generateThumbnails = () => {
    return this.props.slides.map((slide) => (
      <div key={slide.img} className="photo-gallery__thumbnail-wrapper">
        <img className="photo-gallery__thumbnail" src={slide.thumbnail} />
      </div>
    ));
  };

  updateInformation = (_, newIndex) => {
    this.setState({
      currentSlide: newIndex,
    });
  };

  renderThumbnailSlider = () => {
    if (this.props.slides.length == 1) {
      return null;
    }

    return (
      <div className="photo-gallery__thumbnails">
        <GalleryArrow onClick={() => this.thumbnailSlider.slickPrev()} />
        <Slider
          className="photo-gallery__thumbnail-slider"
          asNavFor={this.state.previewSlider}
          ref={(slider) => (this.thumbnailSlider = slider)}
          slidesToShow={this.state.visibleThumbnails}
          slidesToScroll={1}
          swipe={true}
          focusOnSelect={true}
          arrows={false}
          speed={200}
        >
          {this.generateThumbnails()}
        </Slider>
        <GalleryArrow direction="right" onClick={() => this.thumbnailSlider.slickNext()} />
      </div>
    );
  };

  renderGalleryInformation = () => {
    const currentSlide = this.state.currentSlide;
    const slides = this.props.slides;
    const currentImage = currentSlide + 1;
    const totalImages = slides.length;
    const currentDescription = slides[currentSlide].description;

    const information = [
      I18n.t('pages.homes.gallery.current_image', { current_image: currentImage, total_images: totalImages }),
    ];

    if (currentDescription != '') {
      information.push(currentDescription);
    }
    if (respondUntil(MOBILE)) {
      return (
        <span className="photo-gallery__info-text">
          {currentImage}/{totalImages}
        </span>
      );
    }
    return <span className="photo-gallery__info-text">{information.join(': ')}</span>;
  };
}

function GalleryArrow({ direction, onClick }) {
  const arrow = direction == 'right' ? '\u203A' : '\u2039';
  return (
    <div className="photo-gallery__nav-arrow-wrapper" onClick={onClick}>
      <span className="photo-gallery__nav-arrow">{arrow}</span>
    </div>
  );
}

Gallery.defaultProps = {
  maxThumbnailsToShow: 8,
  minThumbnailsToShow: 4,
};
